export default __webpack_public_path__ + "static/media/LogoIcon.56e0ec97.svg";